<template>
	<div class="login-box">
		<div class="login">
			<Icon class="close-icon" type="md-close" size="34" @click="closeLogin" />
			<p class="title">用户登录</p>
			<div class="input-box">
				<p>邮&emsp;&emsp;&emsp;箱</p>
				<input v-model="phone" class="mailbox" placeholder="请输入邮箱" />
			</div>
			<div class="input-box">
				<p>图形验证码</p>
				<img style="width: 132px;height: 40px;" :src="codeUrl" @click="getImgCode" />
				<input v-model="imgCode" placeholder="请输入图形验证码" />
			</div>
			<div class="input-box">
				<p>邮箱验证码</p>
				<div class="sms-btn" :class="{forbid_click:forbidClick}" @click="getSms">{{smsText}}</div>
				<input v-model="password" placeholder="请输入邮箱验证码" />
			</div>
			<div class="login-btn" @click="login">
				{{loginText}}
			</div>
		</div>
	</div>
</template>

<script>
	import { checkMailbox, hasContent } from '@/common/js/assist'
	import api_request_common from '@/http/modules/common'
	export default {
		data() {
			return {
				codeUrl: '',
				phone: '',
				imgCode: '',
				password: '',
				forbidClick: false,
				smsText: '获取验证码',
				loginText: '立即登录',
				flag: false
			}
		},
		mounted() {
			this.getImgCode()
		},
		methods: {
			closeLogin() {
				this.$store.commit('show_login', false);
			},
			login() {
				const v = this;
				if(!checkMailbox(v.phone)) {
					v.$Message.warning("邮箱为空或格式有误，请重新输入");
					return false
				}
				if(!hasContent(v.password)) {
					v.$Message.warning("邮箱验证码不能为空");
					return false
				}
				if(v.flag) return false;
				v.flag = true;
				v.loginText = '登录中...';
				api_request_common.autoRegister(
					v.phone,
					v.password
				).then(res => {
					v.flag = false;
					v.loginText = '立即登录';
					if(res.status == 1) {
						localStorage.setItem("personal_api_token", res.data.api_token);
						localStorage.setItem("user_info", JSON.stringify(res.data));
						v.$store.commit('is_login', true);
						v.$store.commit('show_login', false);
						v.$Message.success('登录成功');
					}
				}).catch(err => {
					v.flag = false;
					v.loginText = '立即登录';
				})
			},
			getSms() {
				const v = this;
				if(!checkMailbox(v.phone)) {
					v.$Message.warning("邮箱为空或格式有误，请重新输入");
					return false
				}
				if(!hasContent(v.imgCode)) {
					v.$Message.warning("图片验证码不能为空");
					return false
				}
				api_request_common.checkImgCode(v.imgCode).then(res => {
					api_request_common.sendSms(v.phone, v.imgCode).then(res => {
						v.forbidClick = true;
						let num = 60;
						v.smsText = "倒计时(" + num + "s)";
						v.timer = setInterval(function() {
							if(num == 0) {
								v.smsText = "获取验证码";
								num = 60;
								clearInterval(v.timer);
								v.forbidClick = false;
								return;
							}
							num--;
							v.smsText = "倒计时(" + num + "s)"
						}, 1000);
					})
				})
			},
			getImgCode() {
				let imgurl = "/api/cpt/show?p=w&width=132&height=40&device_uuid=w&random=" + Math.random()
				this.codeUrl = BASEURL + imgurl;
			}
		}
	}
</script>

<style scoped lang="scss">
	@import '@/common/css/var.scss';
	.login-box {
		position: fixed;
		width: 100%;
		height: 100%;
		top: 0;
		left: 0;
		background: rgba(0, 0, 0, .6);
		.login {
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
			background: #fff;
			box-shadow: 0 1px 20px rgba(0, 0, 0, .3);
			border-radius: 10px;
			padding: 30px 50px;
			.close-icon {
				position: absolute;
				top: 20px;
				right: 20px;
				cursor: pointer;
				&:hover {
					color: $base-color;
				}
			}
			.title {
				font-size: 22px;
				line-height: 150%;
				text-align: center;
				color: #55555a;
				margin-bottom: 20px;
			}
			.input-box {
				overflow: hidden;
				margin-bottom: 20px;
				width: 400px;
				font-size: 14px;
				p {
					float: left;
					line-height: 40px;
					color: #282828;
				}
				input {
					float: right;
					display: block;
					width: 148px;
					height: 40px;
					padding: 0 10px;
					background: none;
					outline: none;
					border: 1px solid #ddd;
					border-radius: 4px;
					line-height: 48px;
					color: #282828;
					&.mailbox {
						width: 300px;
					}
					&:focus {
						border: 1px solid $base-color;
					}
				}
				img {
					float: right;
					margin-left: 20px;
					cursor: pointer;
				}
				.sms-btn {
					float: right;
					width: 132px;
					height: 40px;
					background: $base-color;
					color: #fff;
					border-radius: 5px;
					line-height: 40px;
					margin-left: 20px;
					text-align: center;
					transition: all .2s ease-out 0s;
					cursor: pointer;
					&:active {
						opacity: 0.8;
					}
				}
			}
			.login-btn {
				width: 200px;
				height: 40px;
				margin: 35px auto 0;
				background: $base-color;
				border-radius: 25px;
				font-size: 16px;
				line-height: 40px;
				color: #fff;
				text-align: center;
				transition: all .2s ease-out 0s;
				cursor: pointer;
				&:hover {
					opacity: 0.8;
				}
				&:active {
					transform: scale(1.05);
				}
			}
		}
		/*禁止点击*/
		.forbid_click {
			pointer-events: none;
			color: #fff !important;
			background: #ccc !important;
		}
	}
</style>


// WEBPACK FOOTER //
// src/common/components/login.vue